import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	standalone: true,
	name: 'codeDesignationAngular'
})
export class CodeDesignationCohabitationPipe implements PipeTransform {

	transform(value: any, args?: any): string {
		if (!value || value.code === undefined) {
			return '';
		}
		return value.code.toUpperCase() + ' - ' + value.designation;
	}

}
